export default "<div>{{ GetStatutRapport(status) }}</div>\n";